import React from 'react';
import { Result, Button } from 'antd';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Don't log ResizeObserver or React 19 ref errors
    const errorMessage = error.message || '';
    if (errorMessage.includes('ResizeObserver') || 
        errorMessage.includes('element.ref was removed in React 19') ||
        errorMessage.includes('ref is now a regular prop')) {
      this.setState({ hasError: false, error: null });
      return;
    }
    
    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <Result
          status="error"
          title="Something went wrong"
          subTitle="An unexpected error occurred. Please try refreshing the page."
          extra={[
            <Button type="primary" key="refresh" onClick={() => window.location.reload()}>
              Refresh Page
            </Button>,
            <Button key="back" onClick={() => this.setState({ hasError: false, error: null })}>
              Try Again
            </Button>
          ]}
        />
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;